import { request } from '@/utils/request'

//登录
export function loginApi(data, that) {
    return request({
        url:  '/srm/user/login',
        data: {
            userName: data.userName,
            password: data.password,
        },
        params: {},
        that,
        method: 'post',
    })
}
//查询物料
export function searchMaterial(data, that) {
    return request({
        url:  '/srm/material/searchMaterial',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//查询加工商物料
export function searchProcMaterial(data, that) {
    return request({
        url:  '/srm/procMaterial/query',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//查询采购物料
export function searchPurMaterial(data, that) {
    return request({
        url:  '/srm/material/queryPurMaterial',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//查询加工商
export function searchProcSupplier(data, that) {
    return request({
        url:  '/srm/procSupplier/query',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//查询供应商
export function searchSupplier(data, that) {
    return request({
        url:  '/srm/supplier/searchSupplier',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//查询项目
export function searchProject(data, that) {
    return request({
        url:  '/srm/project/searchProject',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}